import React from 'react';
import { Card, Col, Form, Row } from 'react-bootstrap';
import { useFormContext } from 'react-hook-form';
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import he from 'he';

const ServiceDetails = () => {
  const {
    setValue,
    getValues,
    formState: { errors }
  } = useFormContext();
  const description = getValues('description');
  const decodedDescription = description && he.decode(description);

  const formats = [
    'header',
    'font',
    'size',
    'bold',
    'italic',
    'underline',
    'strike',
    'blockquote',
    'list',
    'bullet',
    'indent',
    'link',
    'image',
    'color', // Include the color format
    'background' // Include the background color format
  ];

  const modules = {
    toolbar: [
      [{ font: [] }], // font dropdown
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      ['bold', 'italic', 'underline', 'strike'], // toggled buttons
      ['blockquote', 'code-block'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ color: [] }, { background: [] }],
      [{ lineheight: ['1', '1.15', '1.5', '2', '2.5', '3'] }][ // dropdown with defaults from theme
        { align: [] }
      ],
      ['link', 'image', 'video'],
      ['clean'] // remove formatting button
    ]
  };

  return (
    <Card className="mb-3">
      <Card.Header as="h6" className="bg-light">
        Контент
      </Card.Header>
      <Card.Body>
        <Row className="gx-2 gy-3">
          <Col xs="12">
            <Form.Group>
              <Form.Label>Дэлгэрэнгүй:</Form.Label>
              <div className="create-product-description-textarea">
                <div style={{ height: '500px' }}>
                  <ReactQuill
                    style={{ height: '400px' }}
                    theme="snow"
                    isInvalid={!!errors.description}
                    onChange={newValue => setValue('description', newValue)}
                    value={decodedDescription}
                    modules={modules}
                    formats={formats}
                  />
                </div>
              </div>
              <Form.Control.Feedback type="invalid">
                {errors.description?.message}
              </Form.Control.Feedback>
            </Form.Group>
          </Col>
        </Row>
      </Card.Body>
    </Card>
  );
};

export default ServiceDetails;
